export default "__VITE_ASSET__599520be__"